<template>
  <view class="pft-t-body">
    <template v-for="(row, rowIndex) in list" :key="row.rowIndex">
      <CompareRowItem v-if="isCompare" :row="row" :compareRow="compareRow(row)" :rowIndex="rowIndex" :columns="columns" />
      <RowItem v-else :row="row" :rowIndex="rowIndex" :columns="columns" />
    </template>
  </view>
</template>

<script lang="ts" setup>
// TODO：props.compareData[rowIndex]是错的，需要重写
import { computed, inject, provide, ref, watch } from "vue"
import { defaultsDeep } from "lodash-es"
import RowItem from "../components/rowItem.vue"
import CompareRowItem from "../components/compareRowItem.vue"

const props = defineProps<{
  data: any[]
  isCompare?: boolean
  columns: any[]
  separated: boolean
  rows: number
}>()

const list = ref<{ [key: string]: string | number }[]>([])

const getCompareRow = inject("getCompareRow") as (row: any) => any

const compareRow = (row: any) => {
  return getCompareRow(row)
}

watch(
  () => props.data,
  () => {
    list.value = props.data.map((item, index) => {
      item.rank = index + 1
      return item
    })
  },

  { immediate: true, deep: true },
)

const rowHeight = ref(32)

const itemClass = (num: number, rank: number) => {
  const classObj = {
    "align-left": props.columns[num].align === "left",
    "align-right": props.columns[num].align === "right",
    dot: props.columns[num].listStyle === "dot",
    "separated-row": props.separated && rank % 2 === 0,
  }
  return classObj
}

provide("itemClass", itemClass)

const itemStyle = (num: number, rowIndex: number) => {
  let defaultVal: any = {
    color: "#a3a6ad",
    height: "32px",
  }
  let style = props.columns[num].style
  if (style instanceof Function) {
    const dataItem = list.value[rowIndex]
    style = style(dataItem)
  }
  const newStyle = defaultsDeep({}, style, defaultVal)
  // console.log("newStyle", rowIndex, props.rows, newStyle)
  if (rowIndex === props.rows) {
    newStyle.height = "0px"
  }
  if (newStyle.height) {
    newStyle.lineHeight = newStyle.height
    rowHeight.value = Number(newStyle.height.replace("px", ""))
  }
  return newStyle
}

provide("itemStyle", itemStyle)
</script>

<style lang="scss" scoped></style>
